import React from "react";

const defaultContext = {};

export const ModalContext = React.createContext(defaultContext);

const initialState = {
  modals: [],
  params: null,
  callback: () => {},
};

export class ModalProvider extends React.Component {
  async componentDidMount() {}

  registerModal() {}
  openModal = (key, params, callback) => {
    const { modals } = this.state;
    this.setState({ modals: [...modals, key], params, callback });
  };

  closeModal = (key, paramsCallBack = {}) => {
    const { modals, callback } = this.state;

    if (typeof callback === "function") {
      callback(paramsCallBack);
    }

    this.setState({
      params: null,
      modals: modals.filter(e => e !== key),
      callback: () => {},
    });
  };

  closeAllModal = key => {
    if (typeof callback === "function") {
      callback();
    }
    this.setState({ modals: [], params: null, callback: () => {} });
  };

  setParams = (params, callback) => {
    this.setState({ params, callback });
  };

  state = {
    ...initialState,
    registerModal: this.registerModal,
    openModal: this.openModal,
    closeAllModal: this.closeAllModal,
    closeModal: this.closeModal,
    setParams: this.setParams,
  };

  render() {
    const { children } = this.props;

    return (
      <ModalContext.Provider value={this.state}>
        {children}
      </ModalContext.Provider>
    );
  }
}

export const withModalContext = Component => props => (
  <ModalContext.Consumer>
    {store => <Component modals={store} {...props} />}
  </ModalContext.Consumer>
);
